/**
 * PC/Linux 错误详情里的 C++ 还原行：模块、地址、函数、文件行。
 * Lua traceback、[C]、tail calls 和报错标题保持原文。
 */

function lastSourcePath(text) {
  const re = /\(([^()]+\.[A-Za-z0-9]+:\d+[^()]*)\)/g;
  let last = null;
  let match = re.exec(text);
  while (match) {
    last = match;
    match = re.exec(text);
  }
  return last;
}

function splitFunctionAndPath(text) {
  const pathMatch = lastSourcePath(text);
  if (!pathMatch) {
    return {
      stackContentBeforeFilePath: String(text || '').trim(),
      filePath: '',
    };
  }
  return {
    stackContentBeforeFilePath: text.replace(pathMatch[0], '').trim(),
    filePath: pathMatch[1],
  };
}

function nativeFrame(raw, libname, hexadecimal, rest) {
  const inlineHeader = '([Inline]';
  let main = rest;
  const inlineLines = [];
  if (rest.includes(inlineHeader)) {
    const parts = rest.split(inlineHeader);
    main = parts[0];
    parts.slice(1).forEach((part) => {
      const cleaned = part.replace(/\)\s*$/, '');
      inlineLines.push(splitFunctionAndPath(cleaned));
    });
  }
  const mainParts = splitFunctionAndPath(main);
  return {
    line: raw,
    rawLine: raw,
    forceFormat: true,
    libname,
    hexadecimal: String(hexadecimal || '').trim(),
    soNameWithoutPath: libname,
    stackContentBeforeFilePath: mainParts.stackContentBeforeFilePath,
    filePath: mainParts.filePath,
    stackContentAfterFilePath: '',
    inlineLines: inlineLines.length ? inlineLines : undefined,
  };
}

function rawLine(raw) {
  return { line: raw, rawLine: raw };
}

export function formatPcErrorStackLine(line) {
  const raw = String(line || '');
  const trimmed = raw.trim();
  if (!trimmed) {
    return rawLine(raw);
  }

  if (raw.includes('\t')) {
    const split = raw.replace(/^\t/, '').split('\t');
    const libname = (split[0] || '').trim();
    const hexadecimal = (split[1] || '').trim();
    const rest = split.slice(2).join('\t');
    if (libname && hexadecimal && !libname.startsWith('[')) {
      return nativeFrame(raw, libname, hexadecimal, rest);
    }
  }

  const bare = trimmed.match(/^(\S+)\s+([0-9a-fA-F]+)\s+([0-9A-Fa-f]{32,40})$/);
  if (bare) {
    return {
      line: raw,
      rawLine: raw,
      forceFormat: true,
      libname: bare[1],
      hexadecimal: bare[2],
      soNameWithoutPath: bare[1],
      soUuid: bare[3],
      stackContentBeforeFilePath: '',
      filePath: '',
      stackContentAfterFilePath: '',
    };
  }

  return rawLine(raw);
}
